import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Menu, MenuItem } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const menuStyle = {
  background: '#c33764',
  color: '#fff',
  borderRadius: 1.5,
  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
  minWidth: 220,
};

const itemStyle = {
  '&:hover': {
    backgroundColor: '#fca138',
    color: '#fff',
  },
  fontWeight: 500,
  px: 2,
  py: 1,
};

const MenuInstitucional: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<ExpandMoreIcon />}
        sx={{ color: '#fff', textTransform: 'none', fontWeight: 500, fontSize: '16px' }}
      >
        A Faculdade
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: menuStyle }}
      >
        <MenuItem onClick={handleClose} component={Link} to="/sobre" sx={itemStyle}>
          Quem Somos
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/mantenedora" sx={itemStyle}>
          Mantenedora
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/estrutura" sx={itemStyle}>
          Estrutura Física
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuInstitucional;
